import { GlobalContext } from 'Global'
import React from 'react'
import { Spin, Icon } from 'antd'

function FullScreenLoading(props) {
  const { fetchingMember } = React.useContext(GlobalContext)

  const antIcon = <Icon type="loading" style={{ fontSize: 124 }} spin />

  return fetchingMember ? (
    <div className="fixed top-0 left-0 z-50 w-screen h-screen flex items-center justify-center">
      <Spin indicator={antIcon} />
    </div>
  ) : (
    props.children
  )
}

export default FullScreenLoading
